import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var BoolHelper =
/*#__PURE__*/
function () {
  function BoolHelper() {
    _classCallCheck(this, BoolHelper);
  }

  _createClass(BoolHelper, [{
    key: "getFriendlyValue",
    value: function getFriendlyValue(value) {
      return value ? "Yes" : "No";
    }
  }]);

  return BoolHelper;
}();

export default new BoolHelper();